import React from 'react';
import { styled } from 'styled-components';

function LinkButtons({ linkSet, naverLink }: any) {
  return (
    <OutLinkContainer>
      <OutLinkBox
        onClick={() => {
          if (linkSet?.landUsePlanLink) {
            window.open(linkSet?.landUsePlanLink || '', '_blank');
          }
        }}
        style={{
          opacity: linkSet?.landUsePlanLink ? 1 : 0.2,
          pointerEvents: linkSet?.landUsePlanLink ? 'auto' : 'none',
          cursor: linkSet?.landUsePlanLink ? 'pointer' : 'not-allowed',
        }}
      >
        토지이음
        <img src="/assets/images/icon/open-in-new.svg" alt="방문하기" />
      </OutLinkBox>

      <OutLinkBox
        onClick={() => {
          if (!linkSet?.serialLink) return;
          window.open(linkSet.serialLink, '_blank');
        }}
        style={{
          opacity: linkSet?.serialLink ? 1 : 0.2,
          pointerEvents: linkSet?.serialLink ? 'auto' : 'none',
          cursor: linkSet?.serialLink ? 'pointer' : 'not-allowed',
        }}
      >
        씨:리얼 지도
        <img src="/assets/images/icon/open-in-new.svg" alt="방문하기" />
      </OutLinkBox>

      <OutLinkBox
        onClick={() => {
          if (!naverLink) return;
          window.open(naverLink?.article_url, '_blank');
        }}
        style={{
          opacity: naverLink ? 1 : 0.2,
          pointerEvents: naverLink ? 'auto' : 'none',
          cursor: naverLink ? 'pointer' : 'not-allowed',
        }}
      >
        네이버 매물
        <img src="/assets/images/icon/open-in-new.svg" alt="방문하기" />
      </OutLinkBox>
    </OutLinkContainer>
  );
}

export default LinkButtons;

const OutLinkContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  /* color: #222222;
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 17.4px;
  word-wrap: break-word; */
`;

const OutLinkBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 2px;
  padding: 10px 8px;
  background-color: #0220470d;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;

  font-weight: 500;
  font-size: 14px;
  color: #000c1ecc;
`;

const OutLinkContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

const ImageMargin = styled.span`
  display: flex;
  max-width: 100%;
  height: auto;
  margin-right: 8px;
`;

const OutLinkLogo = styled.div`
  font-size: 9px;
  font-weight: 500;
  line-height: 17.4px;
  letter-spacing: -0.05em;
  &:first-of-type {
    color: #434d96;
  }
  &:nth-of-type(2) {
    color: #434d96;
  }
  &:last-of-type {
    color: #434d96;
  }
`;

const OutLinkTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  line-height: 17.4px;
  letter-spacing: -0.05em;
`;
